import { render } from "./Reports.vue?vue&type=template&id=70f8e430&scoped=true&ts=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "@/assets/scss/reports.scss?vue&type=style&index=0&id=70f8e430&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f8e430"]])

export default __exports__